import PropTypes from 'prop-types'

const idPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string])

export default idPropType
